@if (pagination.totalItems > 0) {
  @if (tableView$ | async; as tableView) {
    <div class="children-container">
      @if (tableView.loading === false && tableView.hasError === false ) {
        <lib-table
          [dataSummary]="tableView.tableSummary "
          [tableColumns]="tableColumns"
          [pagination]="pagination"
          [displayFilterButtons]="false"
          [displayRefreshButtons]="false"
          [displaySearchInput]="false"
          [searchPlaceholder]="'search.search' | translate"
          [hasRowExpansion]="false"
          [displayCaption]="false"
          (paginationChange)="onPageChange($event)"
          (sortChange)="onSortChange($event)"
          >
        </lib-table>
      }
    </div>
  }
} @else {
  @if (!loading) {
    <p class="no-data-container">
      <i class="fa-solid fa-triangle-exclamation"></i>
      <span>{{'dialog-message.noExportRequestChildrenFound' | translate}} </span>
    </p>
  }
}

